module.exports = __webpack_public_path__ + "img/loader.e4b6323e.gif";